import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as saveAs from 'file-saver';
import { FileUploadService } from 'src/app/services/shared/file-upload.service';

@Component({
  selector: 'app-export',
  templateUrl: './export.component.html',
  styleUrls: ['./export.component.scss']
})
export class ExportComponent {

  isExportProcessing: boolean = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ExportComponent>,
    private fileUploadService: FileUploadService,
  ) {

  }

  downloadCSVFile() {
    const date = new Date();
    const dateString = date.toISOString().substr(0, 10);
    this.isExportProcessing = true;
    this.fileUploadService.exportFile(this.data?.title, (this.data?.exhibitionId) ? (this.data?.exhibitionId) : '').subscribe((res: any) => {
      this.isExportProcessing = false;
      const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, `${this.data?.title}_${dateString}.csv`);
    }, err => {
      this.isExportProcessing = false;
    })
  }
}
